import { AvField } from "availity-reactstrap-validation"
import { Row, Col, Card, CardBody } from "reactstrap"
import ReviewController from "controllers/ReviewController"
import DirectorForm from "../Forms/ReviewDirector.form"
import BaseApplication from "pages/BaseApplication"
import DetailsBasel from "pages/Application/ExportLicense/DetailsBasel"
import DetailsRotterdam from "pages/Application/ExportLicense/DetailsRotterdam"
import DetailsPlasticBags from "../../PlasticBags/DetailsPlasticBags"
import DisposalDetails from "pages/Application/Disposal/DisposalDetails"

import DetailsDeliveryPartner from "pages/Application/DeliveryPartner/Details"
import DetailsAccreditation from "pages/Application/AccreditationRequest/Details"
import DetailsNoObjection from "pages/Application/NoObjectionRequest/Details"
import DetailsEnvironmentalAudit from "pages/Application/EnvironmentalAudit/Details"

import { useEffect, useState } from "react"
import DirectorFormEnvAudit from "../Forms/ReviewDirectorEnvAudit.form"
import DirectorFormNoObjection from "../Forms/ReviewDirectorNoObjection.form"
import DirectorFormAccreditation from "../Forms/ReviewDirectorAccreditation.form"
import DirectorFormDeliveryPartner from "../Forms/ReviewDirectorDeliveryPartner.form"

const reviewController = new ReviewController()

const ReviewDirectorExport = props => {
  const [details, setdetails] = useState()
  const [loading, setloading] = useState(false)
  const [success, setsuccess] = useState(false)
  const [error, seterror] = useState(false)
  const [message, setmessage] = useState("")
  const [directorForm, setdirectorForm] = useState()
  const [serviceType, setserviceType] = useState("")

  useEffect(() => {
    if (serviceType == "auth-plastics") {
      setdirectorForm(
        <DirectorForm
          success={success}
          error={error}
          loading={true}
          message={message}
          appDetails={props.appDetails}
        />
      )
    }

    if (serviceType == "environmental-audit") {
      setdirectorForm(
        <DirectorFormEnvAudit
          success={success}
          error={error}
          loading={true}
          message={message}
          appDetails={props.appDetails}
        />
      )
    }
    if (serviceType == "no-objection") {
      setdirectorForm(
        <DirectorFormNoObjection
          success={success}
          error={error}
          loading={true}
          message={message}
          appDetails={props.appDetails}
        />
      )
    }

    if (serviceType == "accreditation") {
      setdirectorForm(
        <DirectorFormAccreditation
          success={success}
          error={error}
          loading={true}
          message={message}
          appDetails={props.appDetails}
        />
      )
    }

    if (serviceType == "delivery-partner") {
      setdirectorForm(
        <DirectorFormDeliveryPartner
          success={success}
          error={error}
          loading={true}
          message={message}
          appDetails={props.appDetails}
        />
      )
    }
  }, [loading])
  useEffect(() => {
    // console.log("details",props.appDetails)
    setdirectorForm(
      <DirectorForm
        success={success}
        error={error}
        loading={loading}
        message={message}
        appDetails={props.appDetails}
      />
    )
    if (props.appDetails.basel_convention) {
      setdetails(<DetailsBasel appDetails={props.appDetails} />)
    } else if (props.appDetails.auth_plastic_bags) {
      // console.log("yay plastics")
      setserviceType("auth-plastics")
      setdetails(<DetailsPlasticBags appDetails={props.appDetails} />)
    } else if (props.appDetails.guidance_disposal) {
      setdetails(<DisposalDetails appDetails={props.appDetails} />)
    } else if (props.appDetails.delivery_partner_service_request) {
      setserviceType("delivery-partner")
      setdirectorForm(
        <DirectorFormDeliveryPartner
          success={success}
          error={error}
          loading={loading}
          message={message}
          appDetails={props.appDetails}
        />
      )
      setdetails(<DetailsDeliveryPartner appDetails={props.appDetails} />)
    } else if (props.appDetails.accreditation_request) {
      setserviceType("accreditation")
      setdirectorForm(
        <DirectorFormAccreditation
          success={success}
          error={error}
          loading={loading}
          message={message}
          appDetails={props.appDetails}
        />
      )
      setdetails(<DetailsAccreditation appDetails={props.appDetails} />)
    } else if (props.appDetails.no_objection_letter_request) {
      setserviceType("no-objection")
      setdirectorForm(
        <DirectorFormNoObjection
          success={success}
          error={error}
          loading={loading}
          message={message}
          appDetails={props.appDetails}
        />
      )
      setdetails(<DetailsNoObjection appDetails={props.appDetails} />)
    } else if (props.appDetails.environmental_audit_request) {
      setserviceType("environmental-audit")
      setdirectorForm(
        <DirectorFormEnvAudit
          success={success}
          error={error}
          loading={loading}
          message={message}
          appDetails={props.appDetails}
        />
      )
      setdetails(<DetailsEnvironmentalAudit appDetails={props.appDetails} />)
    } else {
      setdetails(<DetailsRotterdam appDetails={props.appDetails} />)
    }
  }, [])

  async function submitReview(values) {
    if (confirm("Do you want to proceed with selected decision?")) {
      setloading(true)
      let response = await reviewController.reviewDirector(values)
      // console.log("jk",values)

      if (response.status) {
        setloading(false)
        setsuccess(true)
        seterror(false)
        setmessage(response.message)

        if (serviceType == "auth-plastics") {
          // console.log("yay submitted plastics")
          setdirectorForm(
            <DirectorForm
              success={true}
              error={false}
              loading={false}
              message={response.message}
              appDetails={props.appDetails}
            />
          )
        }

        if (serviceType == "environmental-audit") {
          setdirectorForm(
            <DirectorFormEnvAudit
              success={true}
              error={false}
              loading={false}
              message={response.message}
              appDetails={props.appDetails}
            />
          )
        }
        if (serviceType == "no-objection") {
          setdirectorForm(
            <DirectorFormNoObjection
              success={true}
              error={false}
              loading={false}
              message={response.message}
              appDetails={props.appDetails}
            />
          )
        }

        if (serviceType == "accreditation") {
          setdirectorForm(
            <DirectorFormAccreditation
              success={true}
              error={false}
              loading={false}
              message={response.message}
              appDetails={props.appDetails}
            />
          )
        }

        if (serviceType == "delivery-partner") {
          setdirectorForm(
            <DirectorFormDeliveryPartner
              success={true}
              error={false}
              loading={false}
              message={response.message}
              appDetails={props.appDetails}
            />
          )
        }
      } else {
        setloading(false)
        setsuccess(false)
        seterror(true)
        setmessage(response.message)

        if (serviceType == "auth-plastics") {
          setdirectorForm(
            <DirectorForm
              success={false}
              error={true}
              loading={false}
              message={response.message}
              appDetails={props.appDetails}
            />
          )
        }

        if (serviceType == "accreditation") {
          setdirectorForm(
            <DirectorFormAccreditation
              success={false}
              error={true}
              loading={false}
              message={response.message}
              appDetails={props.appDetails}
            />
          )
        }

        if (serviceType == "no-objection") {
          setdirectorForm(
            <DirectorFormNoObjection
              success={false}
              error={true}
              loading={false}
              message={response.message}
              appDetails={props.appDetails}
            />
          )
        }

        if (serviceType == "delivery-partner") {
          setdirectorForm(
            <DirectorFormDeliveryPartner
              success={false}
              error={true}
              loading={false}
              message={response.message}
              appDetails={props.appDetails}
            />
          )
        }
      }
    }
  }
  return (
    <>
      <BaseApplication
        title="DG Review Application"
        attachments={props.appDetails.application_attachments}
        appDetails={details}
        submit={submitReview}
        formComponent={directorForm}
        applicationData={props.appDetails}
      />
    </>
  )
}

export default ReviewDirectorExport
